import React from "react";
import EmployerActivation from "../../components/Employer/Activation/EmployerActivation";

const EmployerActivationPage = () => {
  return (
    <div>
      <EmployerActivation />
    </div>
  );
};

export default EmployerActivationPage;
